import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

let hongxingrouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    // {
    //   path: '/gywm',
    //   name: 'companyIntroduction',
    //   meta: {
    //     title: '关于我们'
    //   },
    //   component: () => import('./views/OrganizationalStructure.vue'),
    //   children: [
    //   {
    //     path: '/gywm/companyIntroduction',
    //     name: 'companyIntroduction',
    //     meta: {
    //       title: '公司介绍'
    //     },
    //     component: () => import('./views/CompanyIntroduction.vue'),
    //   },
    //   {
    //     path: '/gywm/organizationalStructure',
    //     name: 'organizationalStructure',
    //     meta: {
    //       title: '组织架构'
    //     },
    //     component: () => import('./views/OrganizationalStructure.vue'),
    //   },
    // ],
    // },
    {
      path: '/gywm/companyIntroduction',
      name: 'companyIntroduction',
      meta: {
        title: '公司介绍'
      },
      component: () => import('./views/CompanyIntroduction.vue')
    },
    {
      path: '/gywm/organizationalStructure',
      name: 'organizationalStructure',
      meta: {
        title: '组织架构'
      },
      component: () => import('./views/OrganizationalStructure.vue')
    },
    {
      path: '/gywm/qualityCommitment',
      name: 'qualityCommitment',
      meta: {
        title: '质量承诺'
      },
      component: () => import('./views/QualityCommitment.vue')
    },
    {
      path: '/gywm/developmentHistory',
      name: 'developmentHistory',
      meta: {
        title: '发展历程'
      },
      component: () => import('./views/DevelopmentHistory.vue')
    },
    {
      path: '/gywm/honoraryQualification',
      name: 'honoraryQualification',
      meta: {
        title: '资质荣誉'
      },
      component: () => import('./views/HonoraryQualification.vue')
    },
    {
      path: '/news/companyNews',
      name: 'companyNews',
      meta: {
        title: '公司新闻'
      },
      component: () => import('./views/CompanyNews.vue')
    },
    {
      path: '/news/industryNews',
      name: 'industryNews',
      meta: {
        title: '信息公开'
      },
      component: () => import('./views/IndustryNews.vue')
    },
    {
      path: '/news/publicAnnouncement',
      name: 'publicAnnouncement',
      meta: {
        title: '公示公告'
      },
      component: () => import('./views/PublicAnnouncement.vue')
    },
    {
      path: '/showProduct',
      name: 'showProduct',
      meta: {
        title: '服务产品'
      },
      component: () => import('./views/ElectromechanicalComponents.vue')
    },
    // {
    //   path: '/showProduct/electronicCeramics',
    //   name: 'electronicCeramics',
    //   meta: {
    //     title: '电子陶瓷'
    //   },
    //   component: () => import('./views/ElectronicCeramics.vue')
    // },
    {
      path: '/showProduct/productDetail/:id',
      name: 'productDetail',
      meta: {
        title: '产品详情'
      },
      component: () => import('./views/ProductDetail.vue')
    },
    {
      path: '/news/newsDetail/:id',
      name: 'newsDetail',
      meta: {
        title: '新闻详情'
      },
      component: () => import('./views/NewsDetail.vue')
    },
    {
      path: '/humanResource/employmentConcept',
      name: 'employmentConcept',
      meta: {
        title: '用人理念'
      },
      component: () => import('./views/EmploymentConcept.vue')
    },
    {
      path: '/humanResource/recruitmentInformation',
      name: 'recruitmentInformation',
      meta: {
        title: '招聘信息'
      },
      component: () => import('./views/RecruitmentInformation.vue')
    },
    {
      path: '/connectUs',
      name: 'connectUs',
      meta: {
        title: '联系我们'
      },
      component: () => import('./views/ConnectUs.vue')
    }
  ],
  base: process.env.BASE_URL
});
// 判断是否需要登录权限 以及是否登录
hongxingrouter.beforeEach((to, from, next) => {
  // 禁用F12
  document.onkeydown = function (event) {
    if (event.key === 'F12') {
      event.preventDefault();
    }
  };
  if (
    to.path === '/gywm/honoraryQualification' ||
    to.path === '/gywm/qualityCommitment'
  ) {
    document.body.oncontextmenu = function () {
      return false;
    };
    document.body.oncopy = function () {
      return false;
    };
    document.onkeydown = function (event) {
      if (event.keyCode == 83) {
        event.preventDefault();
      }
    };
    window.onkeydown =
      window.onkeyup =
      window.onkeypress =
      function (event) {
        // 判断是否按下F12，F12键码为123

        if (event.keyCode == 123) {
          event.preventDefault(); // 阻止默认事件行为

          window.event.returnValue = false;
        }
      };
    // window.addFlags(WindowManager.LayoutParams.FLAG_SECURE)
  } else {
    document.body.oncontextmenu = function () {
      return process.env.NODE_ENV === 'development';
    };
    document.body.oncopy = function () {
      return true;
    };
    window.onkeydown =
      window.onkeyup =
      window.onkeypress =
      function (event) {
        // 判断是否按下F12，F12键码为123

        if (event.keyCode == 123) {
          // event.preventDefault(); // 阻止默认事件行为

          window.event.returnValue = true;
        }
      };
    // document.onkeydown = function (event) {
    //   if ( event.keyCode == 83) {
    //     event.preventDefault();
    //   }
  }
  if (to.path === '/humanResource/campusRecruitment')
    next({
      path: from.path,
      query: {
        redirect: from.path
      }
    });
  next();
});

export default hongxingrouter;
